const state = () => ({
  loading: false,
  errors: [],
  flashErrorMessage: '',
  flashError: false,
  countData: 0,
  countSuccess: 0,
  countFailed: 0,
  uploadProgress: 0,
  onUpload: false,
  insertProgress: 0,
  onInsert: false,
  insertName: '',
  importId: null,
  hasFailedImport: false,
  failedImportController: '',
  failedImportDate: '',
  countDone: 0,
  countSame: 0,
  intervalImport: null,
  intervalInsert: null,
  showProgressBar: false,
  percentage: 0,
  progressTitle: "Processing Request",
  progressColor: "grey",
  isFailedResponse: false,
});

export default state;
